
import Header from "../components/header";
import Sidebar from "../components/sidebar";
import CustomerEdit from "../components/customeredit";
import Footer from "../components/footer";

function CustomerEditPage() {
  return (
    <div>
    <div className='wrapper'>
      <Header />
      <Sidebar /> 
      <CustomerEdit /> 
    </div>
    <Footer /> 
  </div>
  // <Login/>
  );
}
export default CustomerEditPage;
